export default function initGoTopBtn() {
  goTopBtn();
}

/**
 * ページTOPに戻るボタン
 */
function goTopBtn() {
  const goTop = document.getElementById("js-go-top");

  if (!goTop) return;

  goTop.addEventListener("click", function () {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });

  showBtn(); // 初回起動
  window.addEventListener("scroll", showBtn);

  function showBtn() {
    // 一定量スクロールしたら表示
    if (window.pageYOffset > 100) {
      goTop.classList.add("is-show");
    } else {
      goTop.classList.remove("is-show");
    }

    // 特定位置で固定させたい場合
    const fixTrigger = document.querySelector(".js-observer-to-top");
    if (fixTrigger) {
      let triggerRect = fixTrigger.getBoundingClientRect();
      let triggerGutter = 0;

      if (window.innerHeight >= triggerRect.top + triggerGutter) {
        goTop.classList.add("is-fixed");
      } else {
        goTop.classList.remove("is-fixed");
      }
    }
  }
}
